import { render, staticRenderFns } from "./VdaLink.vue?vue&type=template&id=3ea81bde&"
import script from "./VdaLink.vue?vue&type=script&lang=js&"
export * from "./VdaLink.vue?vue&type=script&lang=js&"
import style0 from "./VdaLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports